module.exports = __webpack_public_path__ + "media/icons/tram-23c94b59.svg";